// Draft legal texts (Québec, Loi 25). To be reviewed by a lawyer before public launch.
export const COMPANY = "9571-3681 Québec inc.";
export const CONTACT = "bonjour@tuteurvirtuel.ca";
export const PRIVACY_EMAIL = "confidentialite@tuteurvirtuel.ca";
export const UPDATED = "27 octobre 2026";

export const SMS_CONSENT_TEXT =
  "J’accepte de recevoir des textos de Plan Étude : bilans d’étude et alertes importantes pour le parent, rappels de séances d’étude pour l’élève. Fréquence variable. Des frais de messagerie et de données peuvent s’appliquer. Répondez STOP pour arrêter, HELP pour obtenir de l’aide. Le consentement n’est pas une condition d’utilisation du service.";

export const SMS_PROGRAM = {
  title: "Programme de textos Plan Étude",
  intro: `Plan Étude, exploité par ${COMPANY}, envoie des textos aux familles qui l’ont demandé. Cette page montre comment une personne donne son consentement (opt-in) et les règles du programme.`,
  sections: [
    {
      title: "Comment le consentement est donné",
      body: [
        "Lors de l’inscription sur le site Plan Étude (formulaire « Créer votre compte famille »), le parent inscrit son numéro de téléphone (facultatif) et coche lui-même la case de consentement aux textos ci-dessus, distincte de la case d’acceptation de la politique de confidentialité et des conditions d’utilisation. La case n’est jamais cochée par défaut.",
        "Les textos sont seulement envoyés si la case est cochée et qu’un numéro est fourni. Le consentement peut aussi être activé ou retiré plus tard dans les préférences du compte.",
      ],
    },
    {
      title: "Types de messages",
      body: [
        "Parent : bilan d’étude hebdomadaire de son enfant, alertes importantes (séance manquée, plan à accepter).",
        "Élève : rappel avant une séance d’étude prévue, rappel d’échéance (devoir ou examen).",
        "Aucun message publicitaire ou promotionnel.",
      ],
    },
    {
      title: "Fréquence, frais et aide",
      body: [
        "Fréquence variable.",
        "Des frais de messagerie et de données peuvent s’appliquer selon votre forfait cellulaire.",
        "Répondez STOP pour ne plus recevoir de textos, ou HELP pour obtenir de l’aide. Vous pouvez aussi écrire à " + CONTACT + ".",
      ],
    },
    {
      title: "Confidentialité",
      body: [
        "Aucun numéro de téléphone ni consentement aux textos n’est partagé, vendu ou loué à des tiers ou à des sociétés affiliées à des fins de marketing ou de promotion.",
      ],
    },
    {
      title: "English summary",
      body: [
        `Plan Étude (${COMPANY}) sends study-session reminders to students and weekly study summaries and important alerts to parents. Users opt in by checking an unchecked SMS consent box and entering their phone number on the family sign-up form. Message frequency varies. Message and data rates may apply. Reply STOP to unsubscribe or HELP for help. Contact: ${CONTACT}. No mobile information will be shared with third parties or affiliates for marketing or promotional purposes. Consent is not a condition of using the service.`,
      ],
    },
  ],
};

export const PRIVACY = {
  title: "Politique de confidentialité",
  updated: "30 octobre 2026",
  intro: `Plan Étude est exploité par ${COMPANY} Cette politique explique quels renseignements personnels nous recueillons, pourquoi, et comment vous pouvez exercer vos droits, conformément à la Loi sur la protection des renseignements personnels dans le secteur privé (Québec).`,
  sections: [
    {
      title: "1. Renseignements recueillis",
      body: [
        "Compte parent : nom, courriel, numéro de téléphone (facultatif) et forfait choisi.",
        "Compte élève : prénom, courriel, niveau scolaire et précisions d’apprentissage fournies par le parent.",
        "Utilisation : plans d’étude, séances prévues et réalisées, échéances (devoirs, examens), messages échangés dans l’application et commentaires envoyés.",
        "Photos de travaux : les photos de devoirs ou de notes que l’élève choisit d’envoyer pour obtenir de l’aide.",
        "Données techniques : journaux de connexion nécessaires à la sécurité du service.",
      ],
    },
    {
      title: "2. Pourquoi nous les utilisons",
      body: [
        "Créer et gérer les comptes de la famille.",
        "Proposer, planifier et suivre les séances d’étude, et envoyer les rappels demandés (courriel, et texto si vous y consentez).",
        "Lire les photos de travaux et produire des explications à l’aide d’un service d’intelligence artificielle, à la demande de l’utilisateur.",
        "Envoyer au parent les résumés de progression.",
        "Améliorer le service à partir des commentaires reçus.",
        "Nous ne vendons aucun renseignement personnel et ne faisons aucune publicité ciblée.",
        "Protection des données SMS : les numéros de téléphone et les consentements aux textos ne sont ni vendus ni partagés avec des tiers ou des sociétés affiliées à des fins de marketing ou de promotion. Ils sont utilisés uniquement pour les communications auxquelles vous avez consenti.",
        "Les fournisseurs techniques autorisés, notamment Twilio, traitent uniquement les données nécessaires à l’envoi des messages pour notre compte.",
      ],
    },
    {
      title: "3. Mineurs",
      body: [
        "Le compte d’un élève de moins de 14 ans est créé par son parent ou tuteur, qui consent en son nom. Le parent peut demander à consulter, corriger ou supprimer les renseignements de son enfant, conformément aux lois applicables.",
      ],
    },
    {
      title: "4. Fournisseurs et communication à l’extérieur du Québec",
      body: [
        "Pour fournir le service, nous faisons appel à des fournisseurs qui peuvent traiter des renseignements à l’extérieur du Québec : hébergement et base de données infonuagiques, envoi de courriels, envoi de textos et traitement par intelligence artificielle (lecture des photos et explications).",
        "Ces fournisseurs traitent les renseignements pour nous rendre ces services, selon les engagements de confidentialité applicables. Les communications hors Québec font l’objet des évaluations et mesures de protection requises par la loi.",
      ],
    },
    {
      title: "5. Conservation",
      body: [
        "Les renseignements sont conservés tant que le compte est actif. À la fermeture du compte, ils sont supprimés ou anonymisés dans un délai de 90 jours, sauf obligation légale de les conserver plus longtemps.",
      ],
    },
    {
      title: "6. Sécurité",
      body: [
        "Les mots de passe sont protégés par des mécanismes cryptographiques, les échanges passent par une connexion sécurisée et l’accès aux données est limité aux personnes autorisées.",
        "En cas d’incident de confidentialité présentant un risque de préjudice sérieux, nous avisons les personnes concernées et la Commission d’accès à l’information, conformément à la loi.",
      ],
    },
    {
      title: "7. Vos droits",
      body: [
        "Vous pouvez demander l’accès à vos renseignements, leur rectification, leur suppression lorsque la loi le permet, ou la portabilité de vos données dans les cas prévus par la loi.",
        `Vous pouvez également retirer votre consentement aux textos en répondant STOP. Pour obtenir de l’aide concernant les SMS, répondez HELP ou écrivez à ${CONTACT}.`,
        `Pour exercer vos droits, écrivez à ${PRIVACY_EMAIL}. Nous répondons aux demandes d’accès ou de rectification dans le délai légal de 30 jours, sous réserve des prolongations permises.`,
        "Si vous n’êtes pas satisfait de notre réponse, vous pouvez vous adresser à la Commission d’accès à l’information du Québec.",
      ],
    },
    {
      title: "8. Témoins (cookies)",
      body: ["Plan Étude utilise uniquement le stockage local du navigateur nécessaire à la connexion et au fonctionnement de l’application. Aucun témoin publicitaire n’est utilisé."],
    },
    {
      title: "9. Modifications",
      body: ["Nous publierons toute modification sur cette page avec sa date de mise à jour. En cas de changement important, nous vous en informerons conformément aux lois applicables."],
    },
    {
      title: "10. Nous joindre",
      body: [
        `Plan Étude est un service exploité par ${COMPANY}`,
        "Responsable de la protection des renseignements personnels (Loi 25) : Eric de Gheldere",
        `Courriel : ${PRIVACY_EMAIL}`,
        "Site Web : https://tuteurvirtuel.app",
        "Pour toute question concernant vos renseignements personnels ou pour exercer vos droits, vous pouvez communiquer avec notre responsable à cette adresse.",
      ],
    },
  ],
};

export const TERMS = {
  title: "Conditions d’utilisation",
  updated: "30 octobre 2026",
  intro: `Ces conditions encadrent l’utilisation de Plan Étude, un service offert par ${COMPANY} En créant un compte, vous les acceptez.`,
  sections: [
    {
      title: "1. Le service",
      body: [
        "Plan Étude aide les familles à planifier et suivre des séances d’étude courtes, avec des rappels et une aide à l’étude assistée par intelligence artificielle.",
        "Plan Étude est présentement en bêta privée sur invitation : certaines fonctions peuvent changer, être interrompues ou contenir des erreurs.",
      ],
    },
    {
      title: "2. Comptes",
      body: [
        "Le compte famille est ouvert par un parent ou tuteur majeur, qui est responsable des comptes élèves qu’il crée et de leur utilisation, ainsi que des consentements parentaux requis.",
        "Vous devez fournir des renseignements exacts et garder votre mot de passe confidentiel.",
      ],
    },
    {
      title: "3. Utilisation acceptable",
      body: [
        "N’envoyez que du contenu scolaire : aucune photo de personnes, aucun contenu illégal, offensant ou portant atteinte aux droits d’autrui.",
        "Il est interdit de tenter d’accéder aux comptes d’autres familles ou de perturber le service.",
      ],
    },
    {
      title: "4. Aide par intelligence artificielle",
      body: [
        "Les explications produites par l’intelligence artificielle peuvent comporter des erreurs. Elles servent à guider l’élève et ne remplacent ni l’enseignant ni le jugement du parent.",
      ],
    },
    {
      title: "5. Rappels par courriel et texto",
      body: [
        "Plan Étude peut envoyer des rappels de séances, des alertes scolaires et des bilans de progression.",
        "Les textos nécessitent un consentement distinct et facultatif. Leur fréquence est variable. Des frais de messagerie et de données peuvent s’appliquer.",
        "Vous pouvez désactiver les textos dans l’application ou répondre STOP pour vous désabonner et HELP pour obtenir de l’aide.",
        "Les opérateurs téléphoniques ne sont pas responsables des messages retardés ou non livrés. Le consentement aux textos n’est pas obligatoire pour utiliser le service.",
      ],
    },
    {
      title: "6. Forfaits et paiement",
      body: [
        "Pendant la bêta privée, l’accès est gratuit. Avant tout passage à un forfait payant, nous vous informerons des prix et vous pourrez choisir de continuer ou non.",
      ],
    },
    {
      title: "7. Propriété intellectuelle",
      body: [
        `Le service, son nom et son contenu appartiennent à ${COMPANY} Vous restez propriétaire des contenus que vous ajoutez (plans, photos, notes) et nous accordez seulement le droit de les traiter pour vous offrir le service.`,
      ],
    },
    {
      title: "8. Responsabilité",
      body: [
        "Le service est offert tel quel pendant la bêta. Dans les limites permises par la loi, notamment la Loi sur la protection du consommateur du Québec, nous ne sommes pas responsables des résultats scolaires ni des dommages indirects liés à son utilisation.",
      ],
    },
    {
      title: "9. Fermeture du compte",
      body: [
        `Vous pouvez fermer votre compte en tout temps en écrivant à ${PRIVACY_EMAIL}. Nous pouvons suspendre un compte qui ne respecte pas ces conditions, après vous en avoir avisé lorsque c’est possible.`,
      ],
    },
    {
      title: "10. Droit applicable",
      body: ["Ces conditions sont régies par les lois du Québec et du Canada. Tout litige relève des tribunaux québécois compétents."],
    },
    {
      title: "11. Nous joindre",
      body: [
        `Entreprise : ${COMPANY}`,
        `Courriel : ${PRIVACY_EMAIL}`,
        { prefix: "Confidentialité : ", label: "Politique de confidentialité", to: "/confidentialite" },
      ],
    },
  ],
};
